module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "box grid grid-responsive week_notes_lesson_note",
    style: ({
      borderColor: _vm.event.color
    })
  }, [_c('div', {
    staticClass: "col-2-12 box-size"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.event.title) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm._f("timeStamp")(_vm.event.start)) + " - " + _vm._s(_vm._f("timeStamp")(_vm.event.end))), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-10-12"
  }, [_c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "word-break",
    domProps: {
      "innerHTML": _vm._s(_vm.learningGoal)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "word-break",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3"
  }, [_c('div', {
    staticClass: "word-break",
    domProps: {
      "innerHTML": _vm._s(_vm.notes_for_students)
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-734f9ae5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/weekplan/WeekPlanLesson.vue
// module id = 1652
// module chunks = 1